export const getImageSize = (src: string) => {
  return new Promise<{ width: number; height: number }>((resolve, reject) => {
    const imageEl = new Image()

    imageEl.onload = () => {
      resolve({
        width: imageEl.naturalWidth,
        height: imageEl.naturalHeight,
      })
    }

    imageEl.onerror = reject

    imageEl.src = src
  })
}
